import { connectedStore } from '../../store';
import selectors from '../selectors';

const getSiteName = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getSiteName(state);
};

export default getSiteName;
